import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import eventBus from './eventBus';
import { lo } from 'element-plus/es/locales.mjs';

// 挂载Pusher到window（Echo依赖）
window.Pusher = Pusher;

class SocketService {
    constructor() {
        // 初始化属性
        this.instance = null; // Echo实例（替代原生WebSocket）
        this.isConnected = false; // 连接状态
        this.callbacks = new Map(); // 回调函数存储
        this.config = null; // 配置参数
        this.reconnectAttempts = 0; // 重连尝试次数
        this.maxReconnectAttempts = 5; // 最大重连次数
        this.reconnectDelay = 3000; // 重连延迟时间（毫秒）
    }

    /**
     * 初始化Socket实例
     * @param {Object} config 配置参数（包含Echo所需参数）
     */
    init(config) {
        this.config = config;
        this.instance = null;
        this.isConnected = false;
        return this;
    }

    /**
     * 重连逻辑
     */
    reconnect() {
        if (this.reconnectAttempts >= this.maxReconnectAttempts) {
            console.error('❌ 已达到最大重连次数，停止重连');
            return;
        }

        this.reconnectAttempts++;
        console.log(`🔄 尝试第 ${this.reconnectAttempts} 次重连...`);

        setTimeout(() => {
            this.connect()
                .then(() => {
                    console.log('✅ 重连成功！');
                    this.reconnectAttempts = 0; // 重置重连次数
                })
                .catch((error) => {
                    console.error('❌ 重连失败:', error);
                    this.reconnect(); // 继续重连
                });
        }, this.reconnectDelay);
    }

    /**
     * 连接WebSocket（基于Echo实现，返回Promise保持一致）
     * @returns {Promise}
     */
    connect() {
        return new Promise((resolve, reject) => {
            if (!this.config) {
                reject(new Error('Socket未初始化，请先调用init方法'));
                return;
            }

            if (this.instance) {
                console.log('WebSocket already connected');
                return;
            }

            // 解构Echo配置参数
            const {
                app_key,
                serverUrl,
            } = this.config;

            const authToken = localStorage.getItem('token'); // 获取Token（如果需要）

            // 创建Echo实例（核心替换：原生WebSocket → Echo）
            this.instance = new Echo({
                broadcaster: 'pusher',
                key: app_key,
                cluster: '', // 明确设置为空字符串，避免使用Pusher云服务
                wsHost: serverUrl.hostname, // 使用当前页面的域名
                wsPath: '/laravel-websockets',
                forceTLS: true,
                enabledTransports: ['ws', 'wss'],
                auth: {
                    headers: {
                        'Authorization': `Bearer ${authToken}` // 在请求头中包含Token
                    },
                    credentials: true // 跨域时允许发送cookie
                },
                disableStats: true
            });

            // 监听连接成功（Echo不同广播器的连接监听方式）
            // if (broadcaster === 'pusher') {
                // Pusher连接成功监听
                // this.instance.connector.pusher.connection.bind('connected', () => {
                //     this.isConnected = true;
                //     console.log('WebSocket(Echo)连接成功');
                //     resolve(true);
                // });

                // // Pusher连接错误监听
                // this.instance.connector.pusher.connection.bind('error', (error) => {
                //     console.error('WebSocket(Echo)错误:', error);
                //     this.isConnected = false;
                //     reject(error);
                // });
                const self = this;
                // 监听连接成功
                this.instance.connector.pusher.connection.bind('connected', function() {
                    self.isConnected = true;
                    resolve(true);
                    console.log('✅ Echo连接成功！连接状态：已连接', 'success');
                    console.log(`连接ID: ${self.instance.connector.pusher.connection.socket_id}`, 'info');
                });
                
                // 监听连接中状态
                this.instance.connector.pusher.connection.bind('connecting', function() {
                    console.log('🔄 Echo连接中...', 'info');
                });
                
                // 监听连接断开
                this.instance.connector.pusher.connection.bind('disconnected', function() {
                    console.log('❌ Echo连接已断开', 'error');
                    self.isConnected = false;
                    self.reconnect(); // 触发重连
                });
                
                // 监听连接失败
                this.instance.connector.pusher.connection.bind('failed', function() {
                    console.log('❌ Echo连接失败', 'error');
                });
                
                // 监听状态变化
                this.instance.connector.pusher.connection.bind('state_change', function(states) {
                    console.log(`🔄 Echo连接状态变化: ${states.previous} -> ${states.current}`, 'info');
                });
                
                // 监听连接建立事件
                this.instance.connector.pusher.connection.bind('connected', function() {
                    console.log('✅ Echo连接已建立', 'success');
                });
                
                // 监听连接建立事件（pusher协议）
                this.instance.connector.pusher.connection.bind('pusher:connection_established', function(data) {
                    console.log(`✅ Pusher连接已建立: ${JSON.stringify(data)}`, 'success');
                });
                
                // 监听错误
                this.instance.connector.pusher.connection.bind('error', function(error) {
                    self.isConnected = false;
                    console.log(`❌ Echo连接错误: ${JSON.stringify(error)}`, 'error');
                    reject(error);
                });
                
                // 监听频道订阅成功
                this.instance.connector.pusher.connection.bind('subscription_succeeded', function(data) {
                    console.log(`✅ 频道订阅成功: ${data.channel}`, 'success');
                });
                
                // 监听频道订阅错误
                this.instance.connector.pusher.connection.bind('subscription_error', function(data) {
                    console.log(`❌ 频道订阅失败: ${data.channel}`, 'error');
                });
                
                console.log('Echo连接状态监听器已设置完成', 'success');
            // }
            //  else if (broadcaster === 'socket.io') {
            //     // Socket.io连接成功监听
            //     this.instance.connector.socket.on('connect', () => {
            //         this.isConnected = true;
            //         console.log('WebSocket(Echo)连接成功');
            //         resolve(true);
            //     });

            //     // Socket.io连接错误监听
            //     this.instance.connector.socket.on('connect_error', (error) => {
            //         console.error('WebSocket(Echo)错误:', error);
            //         this.isConnected = false;
            //         reject(error);
            //     });

            //     // Socket.io连接关闭监听
            //     this.instance.connector.socket.on('disconnect', () => {
            //         console.log('WebSocket(Echo)连接关闭');
            //         this.isConnected = false;
            //     });
            // }

            // 全局消息监听（统一处理所有收到的事件）
            this.instance.connector.pusher?.bind_global((eventName, data) => {
                this.handleMessage({ event: eventName, payload: data });
            });
            this.instance.connector.socket?.on('*', (packet) => {
                const [eventName, data] = packet;
                this.handleMessage({ event: eventName, payload: data });
            });
        });
    }

    /**
     * 处理接收到的消息（与上传文件完全一致）
     * @param {Object} message 消息数据（适配Echo格式）
     */
    handleMessage(message) {
        // console.log('收到消息:', message);
        try {
            const { channel, event, payload } = message;

            // 触发对应频道和事件的回调
            const key = `${channel}:${event}`;
            if (this.callbacks.has(key)) {
                this.callbacks.get(key)(payload);
            }

            // 触发全局消息事件
            if (this.callbacks.has('*')) {
                this.callbacks.get('*')(message);
            }
            if(payload && payload.channel) {
                console.log('触发全局事件总线:', `${ payload.channel }:${ event }`, message, eventBus);
                eventBus.emit(`${ payload.channel }:${ event }`, message);
            }
        } catch (error) {
            console.error('消息解析错误:', error);
        }
    }

    /**
     * 订阅频道事件（与上传文件一致，内部调用Echo订阅）
     * @param {String} channel 频道名
     * @param {String} event 事件名
     * @param {Function} callback 回调函数
     */
    subscribe(channel, event, callback) {
        if (!this.isConnected) {
            console.warn('WebSocket未连接，无法订阅');
            return;
        }
        let channels = localStorage.getItem('subscribed_channel') || '';
        if(channels && !channels.split(',').includes(channel)) {
            channels += `,${channel}`;
        } else if(!channels) {
            channels = channel;
        }
        localStorage.setItem('subscribed_channel', channels); // 存储当前订阅的频道（可选）
        console.log(`订阅频道: ${channel}, 事件: ${event}`);
        const key = `${channel}:${event}`;
        this.callbacks.set(key, callback);

        // 区分频道类型（公开/私有/存在）
        let echoChannel;
        if (channel.startsWith('private-')) {
            echoChannel = this.instance.private(channel);
        } else if (channel.startsWith('presence-')) {
            echoChannel = this.instance.presence(channel);
        } else {
            echoChannel = this.instance.channel(channel);
        }
        console.log('echoChannel', echoChannel)
        // 订阅事件（Echo方式）
        echoChannel.listen(event, (payload) => {
            console.log('接收到消息:', payload);
            this.handleMessage({ channel, event, payload });
        });
    }
    
    /**
     * 订阅频道事件（与上传文件一致，内部调用Echo订阅）
     * @param {String} channel 频道名
     * @param {String} event 事件名
     * @param {Function} callback 回调函数
     */
    subscribes(channel, events) {
        if (!this.isConnected) {
            console.warn('WebSocket未连接，无法订阅');
            return;
        }
        let channels = localStorage.getItem('subscribed_channel') || '';
        if(channels && !channels.split(',').includes(channel)) {
            channels += `,${channel}`;
        } else if(!channels) {
            channels = channel;
        }
        localStorage.setItem('subscribed_channel', channels); // 存储当前订阅的频道（可选）

        // 区分频道类型（公开/私有/存在）
        let echoChannel;
        if (channel.startsWith('private-')) {
            echoChannel = this.instance.private(channel);
        } else if (channel.startsWith('presence-')) {
            echoChannel = this.instance.presence(channel);
        } else {
            echoChannel = this.instance.channel(channel);
        }
        console.log('echoChannel', echoChannel)

        if (Array.isArray(events) && events.length) {
            events.forEach(item => {
                const key = `${channel}:${item.name}`;
                this.callbacks.set(key, item.callback);
                if (item.name && typeof item.callback === 'function') {
                    echoChannel.listen(item.name, item.callback);
                }
            });
        }

        // console.log(`订阅频道: ${channel}, 事件: ${event}`);
        

        
        // // 订阅事件（Echo方式）
        // echoChannel.listen(event, (payload) => {
        //     console.log('接收到消息:', payload);
        //     this.handleMessage({ channel, event, payload });
        // });
    }

    /**
     * 订阅频道事件（与上传文件一致，内部调用Echo订阅）
     * @param {String} channel 频道名
     * @param {String} event 事件名
     * @param {Function} callback 回调函数
     */
    subscribes2(channel, events) {
        if (!this.isConnected) {
            console.warn('WebSocket未连接，无法订阅');
            return;
        }
        let channels = localStorage.getItem('subscribed_channel') || '';
        if(channels && !channels.split(',').includes(channel)) {
            channels += `,${channel}`;
        } else if(!channels) {
            channels = channel;
        }
        localStorage.setItem('subscribed_channel', channels); // 存储当前订阅的频道（可选）

        // 区分频道类型（公开/私有/存在）
        let echoChannel;
        if (channel.startsWith('private-')) {
            echoChannel = this.instance.private(channel);
        } else if (channel.startsWith('presence-')) {
            echoChannel = this.instance.presence(channel);
        } else {
            echoChannel = this.instance.channel(channel);
        }
        console.log('echoChannel', echoChannel)

        if (Array.isArray(events) && events.length) {
            events.forEach(item => {
                const key = `${channel}:${item.name}`;
                this.callbacks.set(key, item.callback);
                if (item.name && typeof item.callback === 'function') {
                    channel.listen(item.name, item.callback);
                }
            });
        }

        // console.log(`订阅频道: ${channel}, 事件: ${event}`);
        

        
        // // 订阅事件（Echo方式）
        // echoChannel.listen(event, (payload) => {
        //     console.log('接收到消息:', payload);
        //     this.handleMessage({ channel, event, payload });
        // });
    }

    /**
     * 取消订阅（与上传文件一致）
     * @param {String} channel 频道名
     * @param {String} event 事件名
     */
    unsubscribe(channel, event) {
        let channels = localStorage.getItem('subscribed_channel') || '';
        if(channels) {
            channels = channels.split(',').filter(c => c !== channel).join(',');
            localStorage.setItem('subscribed_channel', channels); // 更新存储的频道列表
        }
        const key = `${channel}:${event}`;
        this.callbacks.delete(key);

        // 取消Echo的事件监听
        if (this.instance) {
            let echoChannel;
            if (channel.startsWith('private-')) {
                echoChannel = this.instance.private(channel);
            } else if (channel.startsWith('presence-')) {
                echoChannel = this.instance.presence(channel);
            } else {
                echoChannel = this.instance.channel(channel);
            }
            echoChannel.stopListening(event);
        }
    }

    /**
     * 发送消息（与上传文件一致，Echo通过触发事件实现）
     * @param {String} channel 频道名
     * @param {String} event 事件名
     * @param {Object} data 消息数据
     */
    send(channel, event, data) {
        if (!this.isConnected) {
            console.warn('WebSocket未连接，无法发送消息');
            return;
        }

        // Echo发送事件
        const pusher = this.instance.connector.pusher;
        const pusherChannel = pusher.channel(channel);
        if(pusherChannel) {
            pusherChannel.trigger(event, data);
        } else {
            let channels = localStorage.getItem('subscribed_channel') || '';
            if(channels) {
                channels = channels.split(',').filter(c => c !== channel).join(',');
                localStorage.setItem('subscribed_channel', channels); // 更新存储的频道列表
            }
            eventBus.emit('onSocketConnect');
            console.log(`频道 ${channel} 不存在，无法发送消息`);
        }
    }

    /**
     * 断开连接（与上传文件一致）
     */
    disconnect() {
        if (this.instance) {
            this.instance.disconnect(); // Echo断开连接
            this.instance = null;
            this.isConnected = false;
            this.callbacks.clear();
            localStorage.removeItem('subscribed_channel'); // 清除存储的频道列表
        }
    }
}

// 创建单例实例（与上传文件一致）
const socketService = new SocketService();

// 安装Vue插件（与上传文件一致）
// export function install(app) {
//     app.config.globalProperties.$socket = socketService;
//     app.provide('socket', socketService);
// }

// 导出服务（与上传文件一致）
export default socketService;